jQuery(document).ready(function(){
	
	jQuery('.home-slider').slick({
		centerMode: false,
		slidesToShow: 5,
		infinite: true,
		prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
		nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
		responsive: [
		    {
				breakpoint: 736,
				settings: {
				slidesToShow: 2
				}
			}
		]
  });

jQuery('.side-slider').slick({
		centerMode: false,
		slidesToShow: 1,
		infinite: true,
		prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
		nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>'
  
  });
  
  jQuery('.designer-gallery').slick({
		centerMode: false,
		slidesToShow: 3,
		infinite: true,
		prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
		nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
		responsive: [
		    {
				breakpoint: 736,
				settings: {
				slidesToShow: 1
				}
			}
		]
  
  });
  
    jQuery('.designer-slider > div').slick({
		centerMode: false,
		slidesToShow: 4,
		infinite: true,
		arrows: false,
		adaptiveHeight: true,
		responsive: [
		    {
				breakpoint: 736,
				settings: {
				slidesToShow: 2
				}
			}
		]
  
  });
  
  
      jQuery( '.testimonial-slider' ).slick({
		centerMode: false,
		slidesToShow: 1,
		infinite: true,
		prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
		nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
		adaptiveHeight: true
  
  });


	 
});